import { getAccountPublicPath } from "./utils";
/**
 * Account Centre module federation config
 *
 * Scope - The scope name defined in Account Centre's ModuleFederationPlugin "name" object.
 * Remote Entry - `${publicPath}/${remoteEntryPath}` should be equal to the remote entry url for account centre.
 */
export const ACC_CONFIG = {
    scope: "membership",
    publicPath: getAccountPublicPath(), // e.g. https://www.cbc.ca/account-centre/a
    remoteEntryPath: "scripts/remoteEntry.js",
    sentryScopeId: "scope-account-centre",
};

/**
 * Account Centre federated modules
 *
 * moduleName - The module name defined in Account Centre's ModuleFederationPlugin "exposes" object.
 * exportName - The export name of the desired module, if undefined, all module exports and the default export are returned.
 */
export const ACC_MODULES = {
    setPublicPath: {
        moduleName: "./public-path",
        exportName: "set",
    },
    loadLoginRadius: {
        moduleName: "./utilsLibraryIndex",
        exportName: "loadLoginRadius",
    },
    initMembershipStore: {
        moduleName: "./utilsLibraryIndex",
        exportName: "initMembershipStore",
    },
    getSessionToken: {
        moduleName: "./utilsLibraryActions",
        exportName: "getSessionToken",
    },
    checkLoggedInStatus: {
        moduleName: "./actions",
        exportName: "checkLoggedInStatus",
    },
    validateAccessToken: {
        moduleName: "./actions",
        exportName: "validateAccessToken",
    },
    logout: {
        moduleName: "./actions",
        exportName: "logout",
    },
    RemoteAccountNav: {
        moduleName: "./RemoteAccountNav",
    },
    RemotePageAccount: {
        moduleName: "./RemotePageAccount",
    },
};
